import {serializeReviewAnalysisDate} from '../../../page/main/reviews-analysis/reviews-analysis-helper';
import {serialize} from '../../../util/api-adapter';
import {FetchMethodEnum} from '../../../util/fetch';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../../api/api-const';

import {AiMessagePayloadType} from './review-analysis-ai-message-type';

// Mirror of the backend RocketGPT contract (same values the AI-summary path uses):
// 204 => the answer streams over Centrifugo; 200 {status: 'insufficient_data'} => no data to
// analyse (the AI call was skipped); 412 => the daily quota is exhausted.
const ROCKET_GPT_QUOTA_STATUS_CODE = 412;
const ROCKET_GPT_NO_CONTENT_STATUS_CODE = 204;

export const AI_CHAT_INSUFFICIENT_STATUS = 'insufficient_data';

// null => 204 (streaming); {status} => 200 (e.g. insufficient_data).
export async function sendMessageToReviewAnalysisAiChat(
    messagePayload: AiMessagePayloadType
): Promise<{status?: string} | null> {
    const {searchParams, filterKey, ...restMessagePayload} = messagePayload;

    const url = `${rootApiUrl}/cp/reviews_analytics/rocket_gpt/`;

    const response = await fetch(url, {
        method: FetchMethodEnum.post,
        credentials: 'include',
        headers: {
            ...mainApiHeaders,
            ...getCsrfHeaders(),
        },
        body: JSON.stringify(
            serialize({
                searchParams: {
                    ...searchParams,
                    ...(searchParams.startDate
                        ? {
                              startDate: serializeReviewAnalysisDate(searchParams.startDate),
                          }
                        : {}),
                    ...(searchParams.endDate
                        ? {
                              endDate: serializeReviewAnalysisDate(searchParams.endDate),
                          }
                        : {}),
                },
                ...(filterKey ? {filterKey} : {}),
                ...restMessagePayload,
            })
        ),
    });

    if (response.status === ROCKET_GPT_QUOTA_STATUS_CODE) {
        const quotaError = new Error('rocket-gpt-quota-exceeded') as Error & {statusCode: number};

        quotaError.statusCode = ROCKET_GPT_QUOTA_STATUS_CODE;
        throw quotaError;
    }

    if (!response.ok) {
        throw new Error('review-analysis-ai-chat-request-failed');
    }

    if (response.status === ROCKET_GPT_NO_CONTENT_STATUS_CODE) {
        return null;
    }

    return response.json();
}
